/**
 * Created by Rodrigo Quesada on 05/01/17.
 */
import moment = require('moment');
import Moment = moment.Moment;

export class LocalDateInterval {
    from?: Moment;
    to?: Moment;

    constructor(jsonData: any = {}) {
        if (jsonData.from) jsonData.from = moment(jsonData.from);
        if (jsonData.to) jsonData.to = moment(jsonData.to);
        Object.assign(this, jsonData);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/common/values/local-date-interval.class.ts